import * as React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';
import { colors } from '../../config/colors';

const Breadcrumb = ({ className, ...props }) => (
  <nav
    aria-label="Breadcrumb"
    className={cn('flex items-center gap-1 text-sm', className)}
    {...props}
  />
);
Breadcrumb.displayName = 'Breadcrumb';

const BreadcrumbItem = ({ className, ...props }) => (
  <div className={cn('inline-flex items-center gap-1', className)} {...props} />
);
BreadcrumbItem.displayName = 'BreadcrumbItem';

const BreadcrumbLink = ({ to, className, children, ...props }) => {
  const style = { color: colors.primary[600] };
  return (
    <Link
      to={to}
      className={cn('hover:underline font-medium', className)}
      style={style}
      {...props}
    >
      {children}
    </Link>
  );
};
BreadcrumbLink.displayName = 'BreadcrumbLink';

const BreadcrumbSeparator = ({ className, ...props }) => (
  <span
    className={cn('flex items-center', className)}
    style={{ color: colors.text.secondary }}
    aria-hidden
    {...props}
  >
    <ChevronRight className="h-4 w-4" />
  </span>
);
BreadcrumbSeparator.displayName = 'BreadcrumbSeparator';

const BreadcrumbPage = ({ className, ...props }) => (
  <span
    className={cn('font-medium', className)}
    style={{ color: colors.text.primary }}
    aria-current="page"
    {...props}
  />
);
BreadcrumbPage.displayName = 'BreadcrumbPage';

export { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, BreadcrumbPage };
